import { ArmyView } from '@Selectors/builder/myBuilder/builder/new/view/ArmyView';
import { ArmySource } from '@Models';

export class ArmyGameView {
  label: string;
  versionId: number;
  source: ArmySource;
  options: Array<ArmyView>;

  constructor(params: ArmyGameViewParams) {
    this.label = params.label;
    this.versionId = params.versionId;
    this.source = params.source;
    this.options = params.options;
  }
}

export type ArmyGameViewParams = {
  label: string;
  versionId: number;
  source: ArmySource;
  options: Array<ArmyView>;
};
